import React from "react";
import { Link } from "react-router-dom";

const AppFooter = () => (
  <footer className="gf-footer">
    <div className="gf-footer__inner">
      <Link to="/guide">Guides</Link>
      <Link to="/about">About</Link>
      <span className="gf-footer__credit">
        Data provided by GitHub. Not affiliated with GitHub Inc.
      </span>
    </div>
  </footer>
);

export default AppFooter;
